import { TextLine } from "../generic/Layout"
import useTranslation from "../../hooks/useTranslation"
import { applyFormula } from "../../../../common/utils/formula/formula.js"

export function mergeText(text, mergeParams, data) {
  return text.replace(/\${(\d+)}/g, (_, index) => {
    const paramIndex = Number(index) - 1;
    const key = mergeParams[paramIndex];
    return key && key in data ? data[key] : 'NotFound';
  });
}

const Description = ({ item, testId, linkedFields }) => {

    const data = { ...linkedFields }

    const {t} = useTranslation()

    const calculatedData = applyFormula(item.calculatedFields || [], data)
    const text = mergeText(t(item.text), item.mergeParams, calculatedData)

    return (
        <TextLine $mt='0rem' $mb='0.75rem' name={item.id}
            data-testid={testId}
        > {text} </TextLine>
    )
}

export default Description
